import { ID_TOKEN_HEADER } from "tng-address-collection-shared/types/portraitsApiTypes.ts";
import { z } from "zod/v4";

export class PortraitApiError extends Error {
  constructor(readonly status: number) {
    super(`Server returned status ${status}`);
  }
}

const sha256Hex = async (text: string) =>
  Array.from(
    new Uint8Array(
      await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text)),
    ),
    (byte) => byte.toString(16).padStart(2, "0"),
  ).join("");

export const callPortraitApi = async <T>(
  path: string,
  schema: z.ZodType<T>,
  {
    token,
    body,
    signal,
  }: { token: string | undefined; body?: object; signal?: AbortSignal },
): Promise<T> => {
  const json = body && JSON.stringify(body);
  const response = await fetch(path, {
    method: json ? "POST" : "GET",
    headers: {
      ...(token && { [ID_TOKEN_HEADER]: token }),
      ...(json && {
        "Content-Type": "application/json",
        // Lambda only accepts a body that CloudFront forwards with its hash
        "x-amz-content-sha256": await sha256Hex(json),
      }),
    },
    body: json,
    signal,
  });

  if (!response.ok) {
    throw new PortraitApiError(response.status);
  }

  return schema.parse(await response.json());
};
